/*
 * Enriched PDP band rhythm. Every content band is optional (blank fields render nothing), so a fixed
 * background per band can put two soft bands — or two white ones — back to back. This alternates
 * soft/white over the bands that actually rendered, in page order:
 *   - the first band after the white buy box is soft;
 *   - the expert-quote band keeps its own color and resets the next band to white.
 * Without JS the CSS defaults apply (kit/compat soft, features soft, specs white).
 * Loaded by sections/pdp-enriched.liquid (up to 3 instances) → guarded to run once.
 */
(function () {
  if (window.__sbaEnrichedBands) return;
  window.__sbaEnrichedBands = true;

  function run() {
    if (!document.body.classList.contains('template__product--enriched')) return;
    // Alternate bottom-up so the LAST band is always soft: below it come the white Product Details / Reviews /
    // FAQ sections, and a white last band ran three whites together (round-2 review, 4-band pages). With an even
    // band count the one unavoidable white-on-white then sits at the top, against the buy box, where it reads as
    // breathing room. The quote band keeps its own color; the band right after it is forced white.
    var bands = document.querySelectorAll('#main .pdp-bcd-quote, #main .pdp-enr, #main .pdp-product-features');
    var soft = true;
    for (var i = bands.length - 1; i >= 0; i--) {
      var el = bands[i];
      if (el.classList.contains('pdp-bcd-quote')) { soft = true; continue; }
      var afterQuote = i > 0 && bands[i - 1].classList.contains('pdp-bcd-quote');
      var s = afterQuote ? false : soft;
      el.classList.toggle('pdp-enr-band--soft', s);
      el.classList.toggle('pdp-enr-band--white', !s);
      soft = !s;
    }
  }

  // Features photo carousel ([data-enr-carousel]): arrows scroll the native scroll-snap track by one card,
  // disable at either end; .is-static (centred, arrows hidden) when every card already fits.
  function initCarousels() {
    var roots = document.querySelectorAll('body.template__product--enriched [data-enr-carousel]');
    Array.prototype.forEach.call(roots, function (root) {
      var track = root.querySelector('.pdp-enr-feats__track');
      var prev = root.querySelector('[data-enr-prev]');
      var next = root.querySelector('[data-enr-next]');
      if (!track) return;
      function step() {
        var card = track.querySelector('.pdp-enr-feat');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        root.classList.toggle('is-static', max <= 0);
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      // Card widths settle after fonts/images load (deferred script) — re-measure then, or a 3-card track that
      // fits keeps dead arrows. ResizeObserver also covers the layout shifting later.
      window.addEventListener('load', update);
      if (window.ResizeObserver) new ResizeObserver(update).observe(track);
      update();
    });
  }

  // Feature photos are meant to be 4:3 lifestyle shots (cropped to fill). Square / portrait cut-outs — e.g. the
  // 2000×2000 fins packshots carried over from the fins template — would lose their top and bottom, so show
  // those whole instead (.is-contain). Decided per image from its real dimensions once loaded.
  function initFeatureFit() {
    var imgs = document.querySelectorAll('body.template__product--enriched .pdp-enr-feats:not(.pdp-enr-feats--products) .pdp-enr-feat__img img');
    Array.prototype.forEach.call(imgs, function (img) {
      function check() {
        if (!img.naturalWidth) return;
        img.parentNode.classList.toggle('is-contain', img.naturalWidth / img.naturalHeight < 1.2);
      }
      // Lazy images off-screen can report complete with no size yet: always listen for load as well.
      check(); img.addEventListener('load', check);
    });
  }

  function init() { run(); initCarousels(); initFeatureFit(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
